import { ChevronRight } from '@mui/icons-material'
import { PlanPurchaseExperienceContext } from '../PlanPurchaseExperienceContext'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { fireHeapEvent } from '@dtx-company/inter-app/src/event-tracking/helpers'
import { styled } from '@mui/system'
import { useContext, useState } from 'react'
import PromoCodeInput from '@app/code/src/components/upgrade/PromoCodeInput'
import theme from '../../../theme'

const _ShowPromoButton = styled('button')`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background: transparent;
  border: 0;
  padding: 0;
`

export const PromoCode = (): JSX.Element => {
  const { promoCodeState } = useContext(PlanPurchaseExperienceContext)
  const [showPromotion, setShowPromotion] = useState(false)

  const showPromoCodeField = showPromotion || promoCodeState.wasLoadedFromQuery
  return (
    <>
      {!showPromoCodeField ? (
        <_ShowPromoButton
          type="button"
          onClick={() => {
            setShowPromotion(prevShowPromotion => !prevShowPromotion)
            fireHeapEvent('Revenue_Upgrade_Clicked_PromoCodeDropdown')
          }}
        >
          <Text component="span" variant="body/small" color={theme.colors.primary.flowBlue}>
            Enter promotion code
          </Text>
          <ChevronRight
            htmlColor={theme.colors.primary.flowBlue}
            style={{ transform: 'rotate(90deg)' }}
          ></ChevronRight>
        </_ShowPromoButton>
      ) : (
        <>
          <Spacer pt="3px"></Spacer>
          <PromoCodeInput
            promoCode={promoCodeState.promoCode}
            setPromoCode={promoCodeState.setPromoCode}
            state={promoCodeState.state}
            onApply={promoCodeState.validatePromoCodeAndSet}
          />
        </>
      )}
    </>
  )
}
